import { FC } from "react";

import { VnBox } from "@/components/VnBox";
import { VnImage } from "@/components/VnImage";
import { VnText } from "@/components/VnText/VnText";
import { useOnboardingIntroContent } from "@/hooks/useOnboardingIntroContent";

const TITLE_CLASS_NAME = "text-start text-xl font-semibold text-white";

// The intro step's clinic logo, title and description, styled for a dark
// background (a photo or the maroon card).
//
// Renders a fragment, so the parent's `gap` sets the space between the logo
// and the text.
export const OnboardingIntroContentOnDark: FC = () => {
  const { clinicLogoBase64, title, description } = useOnboardingIntroContent();

  return (
    <>
      {clinicLogoBase64 && (
        <VnBox className="bg-secondary mx-3 items-center rounded-md px-4 py-2">
          <VnImage
            source={clinicLogoBase64}
            className="h-24 w-full"
            contentFit="contain"
          />
        </VnBox>
      )}

      <VnBox className="gap-3">
        <VnText
          className={TITLE_CLASS_NAME}
          {...title}
          // The default maroon emphasis is unreadable on a dark background.
          i18nProps={{
            components: {
              colorEmphasis: <VnText className={TITLE_CLASS_NAME} />,
            },
          }}
        />
        <VnText
          className="text-start text-white"
          variant="lg"
          {...description}
        />
      </VnBox>
    </>
  );
};
